module.exports = __webpack_public_path__ + "static/media/Yoda.2d565d32.mp3";